export default "__VITE_ASSET__tbD5rxEB__"